import { hostApi } from "@/apis/index";
import Vue from 'vue';

const api_review = `${hostApi}/api/reviews`;
const api_app_review = `${hostApi}/api/app/reviews`;

function getReviewList(params)
{
    return Vue.prototype.$http.get(api_app_review, { params });
}

function createReview(item)
{
    return Vue.prototype.$http.post(`${api_review}/creates`, item);
}

export {
    getReviewList,
    createReview,
};